import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['video', 'placeholder', 'videotogglebtn'];

    connect() {
        this.loaded = false;
        this.userPaused = false; // l'utilisateur a-t-il explicitement mis en pause ?

        // Respect prefers-reduced-motion : on considère que l'utilisateur préfère pause
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reducedMotion) {
            this.userPaused = true;
            this.updateToggleButton('paused');
        } else {
            this.updateToggleButton('playing');
        }

        // Bind handlers
        this.onInteraction = this.onInteraction.bind(this);
        this.onScroll = this.onScroll.bind(this);

        // Pas de chargement auto si reduced-motion ou si l'user a paus avant load
        if (!reducedMotion) {
            this.timer = setTimeout(() => this.loadVideo(), 6000);

            ['mousemove', 'touchstart', 'keydown', 'scroll'].forEach(event => {
                window.addEventListener(event, this.onInteraction, { once: true, passive: true });
            });
        }

        window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    disconnect() {
        clearTimeout(this.timer);
        ['mousemove', 'touchstart', 'keydown', 'scroll'].forEach(event => {
            window.removeEventListener(event, this.onInteraction);
        });
        window.removeEventListener('scroll', this.onScroll, { passive: true });
    }

    onScroll() {
        const threshold = window.innerHeight * 1.5;
        if (window.scrollY > threshold) {
            this.element.setAttribute('data-hideonscroll', 'true');
        } else {
            this.element.removeAttribute('data-hideonscroll');
        }
    }

    onInteraction() {
        clearTimeout(this.timer);
        this.loadVideo();
    }

    loadVideo() {
        if (!this.hasVideoTarget) return;
        if (this.loaded) return;
        this.loaded = true;

        const video = this.videoTarget;

        // Déclenche le chargement en assignant les sources
        video.querySelectorAll('source[data-src]').forEach(source => {
            source.src = source.dataset.src;
        });

        video.load();

        // Ne lance la lecture que si l'utilisateur n'a pas explicitement paus
        if (!this.userPaused) {
            video.play().catch(() => {});
        }

        // Fade in une fois prête
        video.addEventListener('canplay', () => {
            video.setAttribute('data-ready', 'true');
            if (this.hasPlaceholderTarget) {
                this.placeholderTarget.setAttribute('data-hide', 'true');
            }
        }, { once: true });
    }

    /**
     * Action : toggle play/pause depuis le bouton
     * À déclencher via data-action="click->ton-controller#toggleVideo"
     */
    toggleVideo() {
        if (!this.hasVideoTarget) return;
        const video = this.videoTarget;

        // Cas 1 : la vidéo n'est pas encore chargée
        if (!this.loaded) {
            if (this.userPaused) {
                // L'utilisateur veut lancer → on charge maintenant
                this.userPaused = false;
                this.updateToggleButton('playing');
                this.loadVideo();
            } else {
                // L'utilisateur veut paus avant même le chargement
                this.userPaused = true;
                this.updateToggleButton('paused');
                clearTimeout(this.timer);
            }
            return;
        }

        // Cas 2 : vidéo chargée, toggle classique
        if (video.paused) {
            video.play().catch(() => {});
            this.userPaused = false;
            this.updateToggleButton('playing');
        } else {
            video.pause();
            this.userPaused = true;
            this.updateToggleButton('paused');
        }
    }

    /**
     * Met à jour l'état visuel + accessible du bouton
     */
    updateToggleButton(state) {
        if (!this.hasVideotogglebtnTarget) return;
        const btn = this.videotogglebtnTarget;

        btn.dataset.state = state;
        btn.setAttribute(
            'aria-label',
            state === 'playing'
                ? btn.dataset.stoptext
: btn.dataset.starttext
        );
    }
}